<template>
  <footer>

  </footer>
</template>

<script>
  export default {
    data() {
      return {

      }
    },
    methods: {

    },
    components: {},
    props: ['items']
  }

</script>

<style scoped>
  footer {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// Bottom.vue?cbc6b854